/* eslint-disable quotes */
import { ThemeOptions, createTheme } from "@mui/material";

export const muiThemeOptions: ThemeOptions = {
  palette: {
    primary: {
      contrastText: "#fff",
      dark: "#093136",
      light: "#1D878E",
      main: "#0B4549"
    },
    secondary: {
      contrastText: "#fff",
      dark: "#373E4A",
      light: "#6D7B93",
      main: "#58667D"
    },
    text: {
      disabled: "#97A6BF",
      secondary: "#58667D",
      primary: "#252D39"
    },
    background: {
      default: "#F8F9FD",
      paper: "#fff"
    },
    divider: "#E5E8EF",
    success: {
      contrastText: "#fff",
      dark: "#035D47",
      light: "#07A27D",
      main: "#068A6B"
    },
    info: {
      contrastText: "#fff",
      dark: "#195396",
      light: "#4690F5",
      main: "#2A7CDC"
    },
    warning: {
      contrastText: "#fff",
      dark: "#684C00",
      light: "#B48501",
      main: "#9B7200"
    },
    error: {
      contrastText: "#fff",
      dark: "#942828",
      light: "#EA5E54",
      main: "#D93E3E"
    },
    action: {
      focus: "rgba(255,255,255,0.12)",
      disabledBackground: "rgba(255,255,255,0.12)",
      // disabled: "rgba(255,255,255,0.54)", // Color issue
      selected: "rgba(255,255,255,0.92)",
      hover: "rgba(255,255,255,0.9)"
      // active: "rgba(255,255,255,0.54)"
    },
    turquoise: {
      25: "#EFFCFD",
      50: "#AEF5FA",
      100: "#4EE7F1",
      200: "#32CED8",
      300: "#2CB6BF",
      400: "#249EA5",
      500: "#1D878E",
      600: "#167075",
      700: "#115B5F",
      800: "#0B4549",
      900: "#093136"
    },
    gold: {
      25: "#FBF9F6",
      50: "#F3E6D9",
      100: "#EACCAB",
      200: "#E4AF6F",
      300: "#CA9B61",
      400: "#AF8653",
      500: "#967246",
      600: "#7D5E39",
      700: "#654C2D",
      800: "#4E3921",
      900: "#39291A"
    },
    green: {
      25: "#EDFDF7",
      50: "#98FCD9",
      100: "#39ECBB",
      200: "#0CD3A5",
      300: "#0ABB91",
      400: "#07A27D",
      500: "#068A6B",
      600: "#037358",
      700: "#035D47",
      800: "#014735",
      900: "#043326"
    },
    red: {
      25: "#FCF8F8",
      50: "#F7E4E1",
      100: "#F4C7C0",
      200: "#F2A69C",
      300: "#EE8679",
      400: "#EA5E54",
      500: "#D93E3E",
      600: "#B53232",
      700: "#942828",
      800: "#731D22",
      900: "#53151E"
    },
    orange: {
      25: "#FDF8F5",
      50: "#FBE3D3",
      100: "#FCC69E",
      200: "#FEA458",
      300: "#F8830B",
      400: "#D77108",
      500: "#B96006",
      600: "#9A4F04",
      700: "#803E02",
      800: "#682A02",
      900: "#4C1D04"
    },
    blue: {
      25: "#F8F9FD",
      50: "#E2E8FA",
      100: "#C3D2F8",
      200: "#9FBBF9",
      300: "#7AA6F7",
      400: "#4690F5",
      500: "#2A7CDC",
      600: "#2166B8",
      700: "#195396",
      800: "#113F75",
      900: "#0E2D54"
    },
    gray: {
      25: "#F9F9F9",
      50: "#E8E8E8",
      100: "#D1D1D1",
      200: "#BABABA",
      300: "#A4A4A4",
      400: "#8E8E8E",
      500: "#797979",
      600: "#646464",
      700: "#515151",
      800: "#3E3E3E",
      900: "#2C2C2C"
    },
    neutral: {
      25: "#F8F9FD",
      50: "#E5E8EF",
      100: "#CCD2DD",
      200: "#B1BBCD",
      300: "#97A6BF",
      400: "#818FA8",
      500: "#6D7B93",
      600: "#58667D",
      700: "#465267",
      800: "#373E4A",
      900: "#0A3142"
    },
    yellow: {
      25: "#FDF9F1",
      50: "#FDE4BD",
      100: "#FFC855",
      200: "#EBAF01",
      300: "#D09A01",
      400: "#B48501",
      500: "#9B7200",
      600: "#805E00",
      700: "#684C00",
      800: "#503900",
      900: "#3A2900"
    },
    pink: {
      25: "#FDF8FB",
      50: "#FAE1F3",
      100: "#F9C1EB",
      200: "#F99AE6",
      300: "#F872E0",
      400: "#F631DB",
      500: "#D428BD",
      600: "#B1209D",
      700: "#911881",
      800: "#701063",
      900: "#510D48"
    },
    purpure: {
      25: "#FAF9FD",
      50: "#EDE5F9",
      100: "#DBCBF7",
      200: "#C8AFF6",
      300: "#B595F3",
      400: "#9F7AF1",
      500: "#8961EE",
      600: "#6E45EB",
      700: "#4F2AE8",
      800: "#2F13CB",
      900: "#250E94"
    }
    // #fff: {
    //   25: "#FFFFFF",
    //   50: "#FFFFFF",
    //   100: "#FFFFFF",
    //   200: "#FFFFFF",
    //   300: "#FFFFFF",
    //   400: "#FFFFFF",
    //   500: "#FFFFFF",
    //   600: "#FFFFFF",
    //   700: "#FFFFFF",
    //   800: "#FFFFFF",
    //   900: "#FFFFFF"
    // },
    // black: {
    //   25: "#000000",
    //   50: "#000000",
    //   100: "#000000",
    //   200: "#000000",
    //   300: "#000000",
    //   400: "#000000",
    //   500: "#000000",
    //   600: "#000000",
    //   700: "#000000",
    //   800: "#000000",
    //   900: "#000000"
    // }
  },
  boxShadow: {
    xs: "0px 1px 2px 0px rgba(18, 18, 23, 0.05)",
    sm: "0px 1px 2px 0px rgba(18, 18, 23, 0.08), 0px 1px 4px 0px rgba(18, 18, 23, 0.12)",
    md: "0px 2px 4px -1px rgba(18, 18, 23, 0.06), 0px 4px 6px -1px rgba(18, 18, 23, 0.08)",
    lg: "0px 4px 6px -2px rgba(18, 18, 23, 0.05), 0px 10px 15px -3px rgba(18, 18, 23, 0.08)",
    xl: "0px 10px 10px -5px rgba(18, 18, 23, 0.04), 0px 20px 25px -5px rgba(18, 18, 23, 0.10)",
    "2xl": "0px 25px 50px -12px rgba(18, 18, 23, 0.25)",

    "top-xs": "0px -1px 2px 0px rgba(18, 18, 23, 0.05)",
    "top-sm": "0px -1px 2px 0px rgba(18, 18, 23, 0.06), 0px -1px 3px 0px rgba(18, 18, 23, 0.10)",
    "top-md": "0px -2px 4px -1px rgba(18, 18, 23, 0.06), 0px -4px 6px -1px rgba(18, 18, 23, 0.08)",
    "top-lg": "0px -4px 6px -2px rgba(18, 18, 23, 0.05), 0px -10px 15px -3px rgba(18, 18, 23, 0.08)",
    "top-xl": "0px -10px 10px -5px rgba(18, 18, 23, 0.04), 0px -20px 25px -5px rgba(18, 18, 23, 0.10)",
    "top-2xl": "0px -25px 50px -12px rgba(18, 18, 23, 0.25)",

    "right-xs": "1px 0px 2px 0px rgba(18, 18, 23, 0.05)",
    "right-sm": "1px 0px 4px 0px rgba(18, 18, 23, 0.06), 1px 0px 8px 0px rgba(18, 18, 23, 0.10)",
    "right-md": "2px 0px 4px -1px rgba(18, 18, 23, 0.06), 4px 0px 6px -1px rgba(18, 18, 23, 0.08)",
    "right-lg": "4px 0px 6px -2px rgba(18, 18, 23, 0.05), 10px 0px 15px -3px rgba(18, 18, 23, 0.08)",
    "right-xl": "10px 0px 10px -5px rgba(18, 18, 23, 0.04), 20px 0px 25px -5px rgba(18, 18, 23, 0.10)",
    "right-2xl": "25px 0px 50px -12px rgba(18, 18, 23, 0.25);"
  },
  unstable_sxConfig: {
    borderRadius: {
      themeKey: "shape"
    },
    boxShadow: {
      themeKey: "boxShadow"
    }
  },
  // shape: {
  //   xs: 2,
  //   sm: 4,
  //   md: 8,
  //   lg: 16,
  //   xl: 24,
  //   xxl: 32,
  //   xxxl: 40,
  //   "4xl": 64,
  //   "5xl": 128,
  //   round: "50%"
  // },
  spacing: 4,
  typography: {
    fontFamily: "Roboto, sans-serif",
    fontWeightBold: 700,
    fontWeightLight: 300,
    fontWeightMedium: 500,
    fontWeightRegular: 400,
    h3: {
      fontSize: "32px",
      lineHeight: "48px"
    },
    h4: {
      fontSize: "24px",
      lineHeight: "32px"
    },
    h5: {
      fontSize: "20px",
      lineHeight: "28px"
    },
    h6: {
      fontSize: "18px",
      lineHeight: "24px"
    },
    button: {
      textTransform: "none"
    },
    body1: {
      fontSize: "16px",
      lineHeight: "24px"
    },
    body2: {
      fontSize: "15px",
      lineHeight: "24px"
    },
    body3: {
      fontSize: "14px",
      lineHeight: "16px"
    },
    body4: {
      fontSize: "12px",
      lineHeight: "16px"
    }
  },
  components: {
    MuiSvgIcon: {
      variants: [
        {
          props: { fontSize: "xs" },
          style: {
            fontSize: 8
          }
        },
        {
          props: { fontSize: "sm" },
          style: {
            fontSize: 16
          }
        },
        {
          props: { fontSize: "md" },
          style: {
            fontSize: 20
          }
        },
        {
          props: { fontSize: "lg" },
          style: {
            fontSize: 24
          }
        },
        {
          props: { fontSize: "xl" },
          style: {
            fontSize: 32
          }
        }
      ],
      defaultProps: {
        fontSize: "md"
      },
      styleOverrides: {}
    },
    MuiTypography: {
      variants: [
        {
          props: { variant: "button", fontSize: "small" },
          style: {
            fontSize: "14px",
            lineHeight: "16px"
          }
        },
        {
          props: { variant: "button", fontSize: "medium" },
          style: {
            fontSize: "16px",
            lineHeight: "24px"
          }
        }
      ]
    },
    MuiTableCell: {
      styleOverrides: {
        root: {
          fontSize: 13,
          color: "#333333"
        },
        footer: {
          fontWeight: 600,
          color: "#333333"
        }
      }
    },
    MuiSelect: {
      styleOverrides: {
        icon: {
          color: "rgba(0, 0, 0, 0.54)"
        },
        outlined: {
          padding: 10,
          borderRadius: "8px"
        }
      }
    },
    MuiList: {
      styleOverrides: {
        root: {
          backgroundColor: "#fff"
        }
      }
    },
    // MuiFormControl: {
    //   defaultProps: {
    //     sx: { marginBottom: "0px" },
    //   },
    // },
    MuiOutlinedInput: {
      styleOverrides: {
        notchedOutline: {
          "& legend": {
            width: "auto"
          }
        },
        root: {
          borderRadius: "8px",
          "& .MuiInputBase-root.Mui-disabled": {
            "& > fieldset": {
              borderColor: "inherit"
            }
          }
        }
      },
      defaultProps: {
        notched: true
      }
    },
    MuiTableContainer: {
      styleOverrides: {
        root: {
          // maxHeight: "100%",
        }
      }
    },
    MuiButton: {
      variants: [
        {
          props: { size: "sm" },
          style: {
            fontSize: "12px",
            minHeight: 24,
            height: 24,
            padding: "1px 8px",
            gap: 4,
            span: {
              ".MuiSvgIcon-root": {
                fontSize: "16px"
              }
            }
          }
        },
        {
          props: { size: "md" },
          style: {
            fontSize: 16,
            minHeight: 32,
            height: 32,
            padding: "4px 16px",
            gap: 4
          }
        },
        {
          props: { size: "lg" },
          style: {
            fontSize: 16,
            minHeight: 40,
            height: 40,
            padding: "8px 24px",
            gap: 12,
            span: {
              ".MuiSvgIcon-root": {
                fontSize: "24px"
              }
            }
          }
        }
      ],
      styleOverrides: {
        outlined: {
          padding: "0px 18px"
        },
        root: {
          witeSpace: "nowrap",
          borderRadius: "32px",
          // minWidth: "115px",
          minWidth: "65px",
          fontWeight: 400,
          "&:disabled": {
            backgroundColor: "#bac7ce",
            color: "#fff"
          },
          span: {
            margin: 0
          }
        }
      },
      defaultProps: {
        size: "md"
      }
    },
    MuiIconButton: {
      styleOverrides: {
        root: {
          color: "#0A3142"
        }
      },
      variants: [
        {
          props: { size: "sm" },
          style: {
            width: "24px",
            height: "24px",
            padding: 4,
            ".MuiSvgIcon-root": {
              fontSize: "16px"
            }
          }
        },
        {
          props: { size: "md" },
          style: {
            width: "32px",
            height: "32px",
            padding: 6,
            ".MuiSvgIcon-root": {
              fontSize: "20px"
            }
          }
        },
        {
          props: { size: "lg" },
          style: {
            width: "40px",
            height: "40px",
            padding: 8,
            ".MuiSvgIcon-root": {
              fontSize: "24px"
            }
          }
        }
      ],
      defaultProps: {
        size: "md",
        color: "primary"
      }
    },
    MuiFormLabel: {
      styleOverrides: {
        asterisk: { color: "red" }
      }
    },

    MuiTextField: {
      styleOverrides: {
        root: {
          marginBottom: 0,
          ".MuiOutlinedInput-root": {
            borderRadius: "8px"
          }
        }
      },
      defaultProps: {
        InputLabelProps: { shrink: true },
        size: "small",
        // fullWidth: true,
        variant: "outlined"
      }
    },
    MuiAutocomplete: {
      styleOverrides: {
        input: {
          cursor: "pointer"
        },
        option: {
          '&[aria-selected="true"]': {
            backgroundColor: "#edf1f9"
          }
        }
      },
      defaultProps: {
        // InputLabelProps: { shrink: true },
        size: "small"
        // fullWidth: true
      }
    },
    MuiInputLabel: {
      defaultProps: { shrink: true }
    },
    // MuiGrid: {
    //   styleOverrides: {
    //     root: {
    //       marginTop: 0,
    //       marginLeft: 0,
    //       width: "auto"
    //     }
    //   }
    // }
    MuiDivider: {
      styleOverrides: {
        root: {
          backgroundColor: "#5d7782",
          borderColor: "#5d7782"
        }
      }
    },
    MuiChip: {
      styleOverrides: {
        root: {
          backgroundColor: "#eaedef"
        }
      }
    },
    MuiCheckbox: {
      styleOverrides: {
        root: {
          "&.Mui-disabled": {
            color: "rgba(0, 0, 0, 0.26)"
          }
        }
      }
    },
    MuiRadio: {
      styleOverrides: {
        root: {
          "&.Mui-disabled": {
            color: "rgba(0, 0, 0, 0.26)"
          }
        }
      }
    },
    MuiToggleButtonGroup: {
      styleOverrides: {
        grouped: {
          color: "rgba(0, 0, 0, 0.54)"
        }
      }
    }
  }
};

export const muiThemes = createTheme(muiThemeOptions);
